<template>
    <div>
        <h1 style="display: none;">Trang của bạn</h1>
    </div>
</template>

<script>
import firebaseApp from '@/firebase';
import { getDatabase, ref, set, onValue, onDisconnect } from 'firebase/database';
import { getUserLogin } from '@/helper.js'

export default {
    data() {
        return {
            user: {
                id: null,
                email: null,
                google_id: null,
                is_have_password: null,
                user_name: null,
                role: null,
                is_delete: null,
                is_block: null,
                name: null,
                phone: null,
                email_verified_at: null,
                created_at: null,
                updated_at: null,
                access_token: null,
                token_type: null,
                expires_in: null,
            },
        };
    },
    created() {
        this.user = getUserLogin() || {};
        if (this.user && this.user.id) {
            this.trackUserStatus();
        } else {
            console.error('User ID not found. Cannot track status. User data:', this.user);
        }
    },
    methods: {
        trackUserStatus() {
            const db = getDatabase(firebaseApp);
            const userStatusRef = ref(db, `/status/${this.user.id}`); // Đường dẫn: /status/1 (nếu this.user.id là 1)
            // Theo dõi trạng thái kết nối
            onValue(ref(db, '.info/connected'), async (snapshot) => {
                if (snapshot.val() === true) {
                    const lastSeen = new Date().toISOString(); // Ghi thời điểm hiện tại khi offline
                    // User online
                    await set(userStatusRef, {
                        user_id: this.user.id,
                        is_active: 1,
                        last_seen: lastSeen
                    });
                } else {
                    // User offline
                    const lastSeen = new Date().toISOString(); // Ghi thời điểm hiện tại khi offline
                    await set(userStatusRef, {
                        user_id: this.user.id,
                        is_active: 0,
                        last_seen: lastSeen
                    });
                }
            }, (error) => {
                console.error('Error listening to .info/connected:', error);
            });

            // Khi người dùng ngắt kết nối
            const lastSeen = new Date().toISOString(); // Ghi thời điểm hiện tại khi offline
            onDisconnect(userStatusRef).set({
                user_id: this.user.id,
                is_active: 0,
                last_seen: lastSeen
            }).then(() => {
                console.log(`onDisconnect set for user ${this.user.id} to offline with last seen`);
            }).catch((error) => {
                console.error('Error setting onDisconnect:', error);
            });
        }
    }
};
</script>